import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "./AuthContext";

const MarketContext = createContext(null);
const MARKET_KEY = "pf_market";

export function MarketProvider({ children }) {
  const [market, setMarketState] = useState(() => localStorage.getItem(MARKET_KEY) || "SK");
  const [markets, setMarkets] = useState([]);
  const { user } = useAuth();
  const [favIds, setFavIds] = useState([]);

  const setMarket = (m) => {
    localStorage.setItem(MARKET_KEY, m);
    setMarketState(m);
  };

  useEffect(() => {
    api.get("/meta").then(({ data }) => setMarkets(data.markets)).catch(() => {});
  }, []);

  const refreshFavs = useCallback(() => {
    if (user) {
      api.get("/favorites/ids").then(({ data }) => setFavIds(data)).catch(() => setFavIds([]));
    } else {
      setFavIds([]);
    }
  }, [user]);

  useEffect(() => {
    refreshFavs();
  }, [refreshFavs]);

  return (
    <MarketContext.Provider value={{ market, setMarket, markets, favIds, refreshFavs }}>
      {children}
    </MarketContext.Provider>
  );
}

export const useMarket = () => useContext(MarketContext);
